const StationType = {
  Oilco: "oilco",
  Dealer: "dealer",
};

export default StationType;
